import _ from 'lodash';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
    loadTermsList,
    receiveTermsList ,
    getFilteredList,
    selectTerm,
    getRelatedTerms,
    addFavourite
} from '../actions';
import { getValueFromQueryString, formatLocale } from '../../helpers/utils';
import icon_level_1 from '../../assets/images/ico_lv1.svg';
import icon_level_2 from '../../assets/images/ico_lv2.svg';
import icon_level_3 from '../../assets/images/ico_lv3.svg';
import icon_level_4 from '../../assets/images/ico_lv4.svg';

class TermsList extends Component {
    componentDidMount(){
        let termsLocale = 'en-AU';
        const locale = getValueFromQueryString('locale');
        if (locale && formatLocale(locale)) {
            termsLocale = formatLocale(locale);
        }
        this.props.loadTermsList(termsLocale);
        const level = this.props.mathsDictionary.level;
        if (!level){
            this.props.getFilteredList('all');
        } else {
            this.props.getFilteredList(this.props.mathsDictionary.level);
        }
    }

    selectItem(term, index){
        if (term) {
            this.props.selectTerm(term.termName, term.age_group);
            this.props.getRelatedTerms(term, this.props.mathsDictionary.termsList);
        }
    }

    renderTerms(){
        const { mathsDictionary } = this.props;
        const levels = [icon_level_1, icon_level_2, icon_level_3, icon_level_4]
        return _.map(mathsDictionary.filteredList, (term, index) => {
            const imageSrc = `${mathsDictionary.baseUrl}/images/icons/print_${term.file_resource}.png`;
            return (
                <div className={mathsDictionary.isIconView ? 'icon-list-item' : 'list-item'}
                     key={index}
                     onClick={() => { this.selectItem(term, index)
                     }}>
                    <img className="list-image"
                         hidden={!mathsDictionary.isIconView}
                         src={imageSrc}
                         alt={`Image of ${term.file_resource}`}
                     />
                    <div className={mathsDictionary.isIconView ? 'icon-list-text' : 'list-text'}>
                        {term.termName}
                    </div>
                    <img className="age-group-text" src={levels[term.age_group - 1]} alt="level" />
                </div>
            );
        });
    }

    render(){
        const terms = this.props.mathsDictionary.filteredList;
        //if list has not yet been fetched correctly, return Loading div
        if (this.props.mathsDictionary.fetching === true){
            return <div className="list-div">Loading...</div>;
        } else {
            return(
                <div className="list-div">
                    {this.renderTerms()}
                </div>
            );
        }
    }
}

function mapStateToProps(state){
    return { mathsDictionary: state.mathsDictionary }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        loadTermsList,
        receiveTermsList,
        selectTerm,
        getRelatedTerms,
        getFilteredList,
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(TermsList);
